
import { Card, Modal, Spin } from "antd";
import { DownOutlined, DownloadOutlined, UpOutlined } from "@ant-design/icons";
import styled from "styled-components"
import { useEffect, useState } from "react";
import axios from "axios";
import s3Controller from "controllers/s3Controller";

const backend = process.env.REACT_APP_BACKEND;
const StyledCard = styled(Card)`
  margin-bottom: 3px;

  & .ant-card-head-title {
    padding: 4px;
  }
  & .ant-card-body {
    display: none;
  }
  & .ant-card-actions > li {
    margin: 2px;
  }
`

function ImageTabRightImage ({rightBox, stateHandler, gptModel}) {

  const [sourceData, setSourceData] = useState([])
  const [loading, setLoading] = useState(false)

  const getImages = (data) => {
    const WordExMaster_id = data.id
    axios.get(`${backend}/contents/new_word/image/image-list/${WordExMaster_id}`,)
      .then(res => {
        const source = res.data.data.map((el, idx) => {
          el.indexNumber = idx
          return el
        })
        setSourceData(source)
      })
      .catch(err => {
        console.log(err)
      })
  }

  // 삭제
  const deleteImage = (e, el) => {
    const id = el.id
    const WordExMaster_id = el.WordExMaster_id
    const num = el.indexNumber
    const file = "word_image/" + el.word_image_filename

    axios.delete(`${backend}/contents/new_word/image/image-list/${id}/${WordExMaster_id}`)
      .then(res => {
        s3Controller.s3DeleteFile(file, (err, data) => {
          if (err) console.log(err)
        })
        const source = res.data.data.map((el, idx) => {
          el.indexNumber = idx
          return el
        })
        setSourceData(source)

        //단어리스트의 image-count를 변경하기 위한 작업
        const instance = {...rightBox[1]}
        instance.image_count = res.data.data.length
        stateHandler("sourceDataForRightBox", instance)
      })
      .catch(err => {
        console.log(err)
      })
  }

  const upHandler = (id) =>{
    console.log(id)
    const newData = sourceData.slice(0)
    if(id === 0) {
      return
    }

    newData[id].order = newData[id].order -1
    newData[id-1].order = newData[id-1].order +1
    const orderedData = newData.sort((a,b)=>a.order-b.order)

    let ids = []
    const source = orderedData.map((el, idx) => {
      ids.push(el.id)
      el.indexNumber = idx
      el.order = idx +1
      return el
    })
    
    axios.patch(`${backend}/contents/new_word/image/image-list/order`,{ids})
    .then(res=>{
      setSourceData(source)
    })
    .catch(err=>{
      console.log(err)
    })
  }

  const downHandler = (id) => {
    const newData = sourceData.slice(0)
    if(id === newData.length -1) {
      return
    }

    newData[id].order = newData[id].order +1
    newData[id+1].order = newData[id+1].order -1
    const orderedData = newData.sort((a,b)=>a.order-b.order)

    let ids = []
    const source = orderedData.map((el, idx) => {
      ids.push(el.id)
      el.indexNumber = idx
      el.order = idx+1
      return el
    })
    axios.patch(`${backend}/contents/new_word/image/image-list/order`,{ids})
    .then(res=>{
      setSourceData(source)
    })
    .catch(err=>{
      console.log(err)
    })
  }

  const resizingImage = (el, idx) => {
    const size = gptModel.image_downsizing_size
    if(el.word_image_size === size) {
      return
    }
    setLoading(true)
    const filename = el.word_image_filename
    const id = el.id
    axios.patch(`${backend}/contents/new_word/image/image-list/size`, { filename, id, size })
      .then(res => {
        const newData = sourceData.slice()
        newData[idx].word_image_size = size
        setSourceData(newData)
      })
      .catch(err => {
        console.log(err)
        Modal.error({
          title:"리사이징 오류",
          content:"오류가 발생하여 리사이징에 실패했습니다.",
          okText: "확인"
        })
      })
      .finally(()=>{
        setLoading(false)
      })
  }

  useEffect(()=>{
    getImages(rightBox[1])
  },[rightBox])
  
  return (
    <div style={{overflow: "auto"}}>
      {
        sourceData.map((el, idx)=>
          <Spin key={el.id} spinning={loading}>
            <StyledCard
              key={el.id}
              title={
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div>
                    <span>{el.word_image_filename}</span>
                    <span style={{ color: el.word_image_size === "1024x1024" || el.word_image_size === "1024x1792" || el.word_image_size === "1792x1024" ? "red" : null }}>
                      {` (${el.word_image_size})`}
                    </span>
                  </div>
                  <a onClick={(e)=>{deleteImage(e,el)}}>삭제</a>
                </div>
              }
              cover={
                <img style={{ width: "98%", margin: "0 auto" }} src={`https://englemining-admin.s3.ap-northeast-2.amazonaws.com/word_image/${el.word_image_filename}`} />
              }
              actions={[
                <UpOutlined key="up" onClick={()=>{upHandler(idx)}}/>,
                <DownOutlined key="down" onClick={()=>{downHandler(idx)}}/>,
                <DownloadOutlined key="download"onClick={()=>{resizingImage(el,idx)}}/>
              ]}
              bodyStyle={{ padding: 0 }}
              headStyle={{ fontSize: 14, minHeight: "auto", padding: "0px 5px" }}
            ></StyledCard>  
          </Spin>  
        )
      }
    </div>
  )
}

export default ImageTabRightImage